import { memo, splitProps } from '../helpers.js';
import { createRecipe, mergeRecipes } from './create-recipe.js';

const aromaButtonFn = /* @__PURE__ */ createRecipe('aroma-button', {
  "size": "medium",
  "iconOnly": false,
  "hierarchy": "primary-bold",
  "loading": false,
  "active": false
}, [
  {
    "iconOnly": true,
    "size": "small",
    "css": {
      "width": "m"
    }
  },
  {
    "iconOnly": true,
    "size": "medium",
    "css": {
      "width": "xl"
    }
  },
  {
    "iconOnly": true,
    "size": "large",
    "css": {
      "width": "2xl"
    }
  },
  {
    "loading": false,
    "hierarchy": "primary-bold",
    "css": {
      "_disabled": {
        "bgColor": "background.neutral.disable.subtle",
        "borderColor": "transparent",
        "color": {
          "base": "content.neutral.base.disable"
        }
      },
      "_notDisabled": {
        "bgColor": {
          "base": "background.brand.bold",
          "_withinWhiteLabelTheme": "background.brand.safe"
        },
        "color": {
          "base": "content.neutral.reverse.bold"
        },
        "_hover": {
          "bgColor": {
            "base": "background.brand.bold-hover",
            "_withinWhiteLabelTheme": "background.brand.safe-hover"
          }
        },
        "_active": {
          "bgColor": {
            "base": "background.brand.bold-active",
            "_withinWhiteLabelTheme": "background.brand.safe-active"
          }
        },
        "_expanded": {
          "bgColor": {
            "base": "background.brand.bold-active",
            "_withinWhiteLabelTheme": "background.brand.safe-active"
          }
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "primary-subtle",
    "css": {
      "_disabled": {
        "color": {
          "base": "content.neutral.base.disable",
          "_withinWhiteLabelTheme": "content.neutral.base.disable"
        },
        "borderColor": "transparent",
        "bgColor": "background.neutral.disable.subtle"
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": "background.brand.subtler-hover",
          "color": "content.brand.bold-hover",
          "_withinWhiteLabelTheme": {
            "color": "content.brand.subtle"
          }
        },
        "_active": {
          "bgColor": "background.brand.subtler-active"
        },
        "_expanded": {
          "bgColor": "background.neutral.base.subtlest-active"
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "primary-subtler",
    "css": {
      "_disabled": {
        "color": {
          "base": "content.neutral.base.disable",
          "_withinWhiteLabelTheme": "content.neutral.base.disable"
        },
        "borderColor": "transparent",
        "bgColor": "background.neutral.disable.subtle"
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": "background.brand.subtler-hover",
          "color": "content.brand.bold-hover",
          "_withinWhiteLabelTheme": {
            "color": "content.brand.subtle"
          }
        },
        "_active": {
          "bgColor": "background.brand.subtler-active"
        },
        "_expanded": {
          "bgColor": "background.neutral.base.subtlest-active"
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "secondary-bold",
    "css": {
      "_disabled": {
        "bgColor": "background.neutral.disable.subtle",
        "borderColor": "transparent",
        "color": "content.neutral.base.disable"
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": "background.neutral.base.subtle-hover"
        },
        "_active": {
          "bgColor": "background.neutral.base.subtle-active"
        },
        "_expanded": {
          "bgColor": "background.neutral.base.subtle-active"
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "secondary-subtle",
    "active": false,
    "css": {
      "_disabled": {
        "bgColor": "background.neutral.disable.subtle",
        "borderColor": "transparent",
        "color": "content.neutral.base.disable"
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": "background.neutral.base.subtlest-hover",
          "borderColor": "border.neutral.bold-hover",
          "color": "content.neutral.base.bold-hover"
        },
        "_active": {
          "bgColor": "background.neutral.base.subtlest-active",
          "borderColor": "border.neutral.bold"
        },
        "_expanded": {
          "bgColor": "background.neutral.base.subtlest-active",
          "borderColor": "border.neutral.bold"
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "secondary-subtle",
    "active": true,
    "css": {
      "_disabled": {
        "bgColor": "background.neutral.disable.subtle",
        "borderColor": "transparent",
        "color": "content.neutral.base.disable"
      },
      "_notDisabled": {
        "borderColor": "border.brand-bold",
        "color": "content.neutral.base.bold",
        "bgColor": {
          "base": "background.brand.subtle",
          "_hover": "background.brand.subtle-hover",
          "_active": "background.brand.subtle-active",
          "_focusWithin": "background.brand.subtle"
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "secondary-subtler",
    "css": {
      "_disabled": {
        "bgColor": "none",
        "borderColor": "transparent",
        "color": "content.neutral.base.disable"
      },
      "_notDisabled": {
        "color": {
          "base": "content.neutral.base.subtle",
          "_hover": "content.neutral.base.bold-hover"
        },
        "bgColor": {
          "_hover": "background.neutral.base.subtlest-hover",
          "_active": "background.neutral.base.subtlest-active",
          "_expanded": "background.neutral.base.subtlest-active"
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "destructive-bold",
    "css": {
      "_disabled": {
        "bgColor": "background.neutral.disable.subtle",
        "borderColor": "transparent",
        "color": "content.neutral.base.disable"
      },
      "_notDisabled": {
        "color": "content.neutral.reverse.bold",
        "bgColor": {
          "base": "background.functional.error.bold",
          "_hover": "background.functional.error.bold-hover",
          "_active": "background.functional.error.bold-active",
          "_expanded": "background.functional.error.bold-active"
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "destructive-subtle",
    "css": {
      "_disabled": {
        "bgColor": "background.neutral.disable.subtle",
        "borderColor": "transparent",
        "color": "content.neutral.base.disable"
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": "background.functional.error.subtle-hover"
        },
        "_active": {
          "bgColor": "background.functional.error.subtle-active"
        },
        "_expanded": {
          "bgColor": "background.functional.error.subtle-active"
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "destructive-subtler",
    "css": {
      "_disabled": {
        "bgColor": "background.neutral.disable.subtle",
        "borderColor": "transparent",
        "color": "content.neutral.base.disable"
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": "background.functional.error.subtle-hover"
        },
        "_active": {
          "bgColor": "background.functional.error.subtle-active"
        },
        "_expanded": {
          "bgColor": "background.functional.error.subtle-active"
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "brand-reversed-bold",
    "css": {
      "_disabled": {
        "bgColor": {
          "base": "background.neutral.overlay.subtler",
          "_withinWhiteLabelTheme": "background.neutral-on-brand.disabled.reversed"
        },
        "borderColor": "transparent",
        "color": {
          "base": "content.neutral.reverse.disable",
          "_withinWhiteLabelTheme": "content.neutral-on-brand.disabled"
        }
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": {
            "base": "background.brand.complementary",
            "_withinWhiteLabelTheme": "background.neutral-on-brand.base.bold-hover"
          }
        },
        "_active": {
          "bgColor": {
            "base": "background.brand.complementary-reversed",
            "_withinWhiteLabelTheme": "background.neutral-on-brand.base.bold-active"
          }
        },
        "_expanded": {
          "bgColor": {
            "base": "background.brand.complementary-reversed",
            "_withinWhiteLabelTheme": "background.neutral-on-brand.base.bold-active"
          }
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "brand-reversed-subtle",
    "css": {
      "_disabled": {
        "bgColor": {
          "base": "background.neutral.overlay.subtler",
          "_withinWhiteLabelTheme": "background.neutral-on-brand.disabled.reversed"
        },
        "borderColor": "transparent",
        "color": {
          "base": "content.neutral.reverse.disable",
          "_withinWhiteLabelTheme": "content.neutral-on-brand.disabled"
        }
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": {
            "base": "background.brand.bolder-hover",
            "_withinWhiteLabelTheme": "background.neutral-on-brand.base.subtler-hover"
          },
          "borderColor": {
            "base": "border.brand-complementary-reversed",
            "_withinWhiteLabelTheme": "border.neutral-on-brand.bold-hover"
          }
        },
        "_active": {
          "bgColor": "background.brand.bolder-active",
          "borderColor": "border.brand-complementary-reversed",
          "_withinWhiteLabelTheme": {
            "bgColor": "background.neutral-on-brand.base.subtlest-active",
            "borderColor": "border.neutral-on-brand.bolder"
          }
        },
        "_expanded": {
          "bgColor": "background.brand.bolder-active",
          "borderColor": "border.brand-complementary-reversed",
          "_withinWhiteLabelTheme": {
            "bgColor": "background.neutral-on-brand.base.subtlest-active",
            "borderColor": "border.neutral-on-brand.bolder"
          }
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "brand-reversed-subtler",
    "css": {
      "_disabled": {
        "borderColor": "transparent",
        "color": {
          "base": "content.neutral.reverse.disable",
          "_withinWhiteLabelTheme": "content.neutral-on-brand.disabled"
        }
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": {
            "base": "background.brand.bolder-hover",
            "_withinWhiteLabelTheme": "background.neutral-on-brand.base.subtler-hover"
          }
        },
        "_active": {
          "bgColor": "background.brand.bolder-active",
          "_withinWhiteLabelTheme": {
            "bgColor": "background.neutral-on-brand.base.subtlest-active"
          }
        },
        "_expanded": {
          "bgColor": "background.brand.bolder-active",
          "_withinWhiteLabelTheme": {
            "bgColor": "background.neutral-on-brand.base.subtlest-active"
          }
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "reversed-bold",
    "css": {
      "_disabled": {
        "bgColor": "background.neutral.disable.reverse",
        "borderColor": "transparent",
        "color": "content.neutral.reverse.disable"
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": "background.neutral.base.subtlest-hover"
        },
        "_active": {
          "bgColor": "background.neutral.base.subtlest-active"
        },
        "_expanded": {
          "bgColor": "background.neutral.base.subtlest-active"
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "reversed-subtle",
    "css": {
      "_disabled": {
        "bgColor": "background.neutral.disable.reverse",
        "borderColor": "transparent",
        "color": "content.neutral.reverse.disable"
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": "background.neutral.reverse.subtlest-hover",
          "color": "content.neutral.reverse.bold-hover"
        },
        "_active": {
          "bgColor": "background.neutral.reverse.subtlest-active"
        },
        "_expanded": {
          "bgColor": "background.neutral.reverse.subtlest-active"
        }
      }
    }
  },
  {
    "loading": false,
    "hierarchy": "reversed-subtler",
    "css": {
      "_disabled": {
        "bgColor": "background.neutral.disable.reverse",
        "borderColor": "transparent",
        "color": "content.neutral.reverse.disable",
        "_withinWhiteLabelTheme": {
          "bgColor": "transparent"
        }
      },
      "_notDisabled": {
        "_hover": {
          "bgColor": "background.neutral.reverse.subtlest-hover",
          "color": "content.neutral.reverse.bold-hover"
        },
        "_active": {
          "bgColor": "background.neutral.reverse.subtlest-active"
        },
        "_expanded": {
          "bgColor": "background.neutral.reverse.subtlest-active"
        }
      }
    }
  },
  {
    "loading": true,
    "hierarchy": "primary-bold",
    "css": {
      "bgImage": "linear-gradient({colors.background.brand.bold-hover}, {colors.background.brand.bold-hover})",
      "_withinWhiteLabelTheme": {
        "bgImage": "linear-gradient({colors.background.neutral.reverse.subtle}, {colors.background.neutral.reverse.subtle})"
      }
    }
  },
  {
    "loading": true,
    "hierarchy": "primary-subtle",
    "css": {
      "bgImage": "linear-gradient({colors.background.neutral.base.subtlest-hover}, {colors.background.neutral.base.subtlest-hover})"
    }
  },
  {
    "loading": true,
    "hierarchy": "primary-subtler",
    "css": {
      "bgImage": "linear-gradient({colors.background.neutral.base.subtlest-hover}, {colors.background.neutral.base.subtlest-hover})"
    }
  },
  {
    "loading": true,
    "hierarchy": "secondary-bold",
    "css": {
      "bgImage": "linear-gradient({colors.background.neutral.base.subtle-hover}, {colors.background.neutral.base.subtle-hover})"
    }
  },
  {
    "loading": true,
    "hierarchy": "secondary-subtle",
    "css": {
      "bgImage": "linear-gradient({colors.background.neutral.base.subtlest-hover}, {colors.background.neutral.base.subtlest-hover})"
    }
  },
  {
    "loading": true,
    "hierarchy": "secondary-subtler",
    "css": {
      "bgImage": "linear-gradient({colors.background.neutral.base.subtlest-hover}, {colors.background.neutral.base.subtlest-hover})"
    }
  },
  {
    "loading": true,
    "hierarchy": "destructive-bold",
    "css": {
      "bgImage": "linear-gradient({colors.background.functional.error.bold-hover}, {colors.background.functional.error.bold-hover})"
    }
  },
  {
    "loading": true,
    "hierarchy": "destructive-subtle",
    "css": {
      "bgImage": "linear-gradient({colors.background.functional.error.subtle-hover}, {colors.background.functional.error.subtle-hover})"
    }
  },
  {
    "loading": true,
    "hierarchy": "destructive-subtler",
    "css": {
      "bgImage": "linear-gradient({colors.background.functional.error.subtle-hover}, {colors.background.functional.error.subtle-hover})"
    }
  },
  {
    "loading": true,
    "hierarchy": "brand-reversed-bold",
    "css": {
      "bgImage": "linear-gradient({colors.background.brand.subtle-hover}, {colors.background.brand.subtle-hover})"
    }
  },
  {
    "loading": true,
    "hierarchy": "brand-reversed-subtle",
    "css": {
      "bgImage": "linear-gradient({colors.background.brand.bold-hover}, {colors.background.brand.bold-hover})",
      "_withinWhiteLabelTheme": {
        "bgImage": "linear-gradient({colors.background.neutral-on-brand.base.subtle}, {colors.background.neutral-on-brand.base.subtle})"
      }
    }
  },
  {
    "loading": true,
    "hierarchy": "brand-reversed-subtler",
    "css": {
      "bgImage": "linear-gradient({colors.background.brand.bold-hover}, {colors.background.brand.bold-hover})",
      "_withinWhiteLabelTheme": {
        "bgImage": "linear-gradient({colors.background.neutral-on-brand.base.subtle}, {colors.background.neutral-on-brand.base.subtle})"
      }
    }
  },
  {
    "loading": true,
    "hierarchy": "reversed-bold",
    "css": {
      "bgImage": "linear-gradient({colors.background.neutral.base.subtlest-hover}, {colors.background.neutral.base.subtlest-hover})"
    }
  },
  {
    "loading": true,
    "hierarchy": "reversed-subtle",
    "css": {
      "bgImage": "linear-gradient({colors.background.neutral.base.bold-hover}, {colors.background.neutral.base.bold-hover})"
    }
  },
  {
    "loading": true,
    "hierarchy": "reversed-subtler",
    "css": {
      "bgImage": "linear-gradient({colors.background.neutral.base.bold-hover}, {colors.background.neutral.base.bold-hover})"
    }
  },
  {
    "floating": true,
    "hierarchy": "ai-bolder",
    "css": {
      "shadow": "effect.shadow.ai"
    }
  },
  {
    "floating": true,
    "hierarchy": "ai-bold",
    "css": {
      "shadow": "effect.shadow.ai"
    }
  },
  {
    "floating": true,
    "hierarchy": "ai-subtle",
    "css": {
      "shadow": "effect.shadow.ai"
    }
  },
  {
    "floating": true,
    "hierarchy": "ai-subtler",
    "css": {
      "shadow": "effect.shadow.ai"
    }
  }
])

const aromaButtonVariantMap = {
  "size": [
    "small",
    "medium",
    "large"
  ],
  "iconOnly": [
    "true"
  ],
  "fullWidth": [
    "true"
  ],
  "loading": [
    "true"
  ],
  "hierarchy": [
    "primary-bold",
    "primary-subtle",
    "primary-subtler",
    "secondary-bold",
    "secondary-subtle",
    "secondary-subtler",
    "destructive-bold",
    "destructive-subtle",
    "destructive-subtler",
    "brand-reversed-bold",
    "brand-reversed-subtle",
    "brand-reversed-subtler",
    "reversed-bold",
    "reversed-subtle",
    "reversed-subtler",
    "ai-bolder",
    "ai-bold",
    "ai-subtle",
    "ai-subtler"
  ],
  "active": [
    "true"
  ],
  "floating": [
    "true",
    "false"
  ]
}

const aromaButtonVariantKeys = Object.keys(aromaButtonVariantMap)

export const aromaButton = /* @__PURE__ */ Object.assign(memo(aromaButtonFn.recipeFn), {
  __recipe__: true,
  __name__: 'aromaButton',
  __getCompoundVariantCss__: aromaButtonFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: aromaButtonVariantKeys,
  variantMap: aromaButtonVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, aromaButtonVariantKeys)
  },
  getVariantProps: aromaButtonFn.getVariantProps,
})